import baseFetch from 'cross-fetch';

import isBrowser from 'utils/is-browser';
import waitScriptReady from 'utils/wait-for-script-ready';

const CF_SITE_KEY = '0x4AAAAAAB4rTeLDpJ03cfNz';

let captchaPromise: Promise<void> | null;

async function showCaptcha() {
    if (!captchaPromise) {
        captchaPromise = waitScriptReady('cloudflare-turnstile-script')
            .then(() => createTurnstileContainer())
            .then((container) => {
                return new Promise<void>((resolve, reject) => {
                    turnstile.render(container, {
                        ['sitekey']: CF_SITE_KEY,
                        ['error-callback']: (reason) => reject(reason),
                        ['callback']: () => resolve()
                    });
                }).finally(() => {
                    container.remove();
                });
            })
            .finally(() => {
                captchaPromise = null;
            });
    }

    return captchaPromise;
}

async function fetch(...args: Parameters<typeof baseFetch>) {
    const response = await baseFetch(...args);

    if (isBrowser() && isChallengeResponse(response)) {
        return showCaptcha()
            .then(() => baseFetch(...args))
            .catch(() => response);
    } else {
        return response;
    }
}

function createTurnstileContainer() {
    const container = document.createElement('div');
    container.id = 'turnstile_widget';
    Object.assign(container.style, {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        inset: '0',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: '10000'
    });
    document.body.appendChild(container);
    return container;
}

function isChallengeResponse(response: Response) {
    return response.headers.get('cf-mitigated') === 'challenge';
}

export default fetch;
